import Loading from 'components/Loading';
import PropTypes from 'prop-types';
import { last } from 'lodash';
import React, { Component } from 'react';
import { downloadPdfService } from 'services/API';

const fileSaver = require('file-saver');

export default class DownloadPdf extends Component {
  static propTypes = {
    pdf: PropTypes.string,
    filename: PropTypes.string.isRequired,
  };

  static defaultProps = {
    filename: 'file.pdf',
  };

  state = {
    error: false,
    loading: true,
  };

  componentDidMount() {
    const { pdf, filename } = this.props;
    downloadPdfService(pdf)
      .then((res) => {
        if (res.isOk) {
          return res.data;
        }

        throw res.error;
      })
      .then((pdfData) => {
        const extension = last(filename.split('.')) || 'pdf';
        const blob = new Blob([pdfData], {
          type: `application/${extension};charset=utf-8`,
        });

        fileSaver.saveAs(blob, filename, true);
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        window.console.error(err);
        this.setState({
          error: true,
          loading: false,
        });
      });
  }

  getErrorMessage() {
    const { error, loading } = this.state;
    if (error) {
      return loading
        ? 'Документ формируется. Пожалуйста, подождите.'
        : 'Ошибка формирования документа.';
    }

    return 'Загрузка документа началась.';
  }

  render() {
    const { loading } = this.state;
    return (
      <div className="page">
        <div className="page-title_block">
          <h2 style={{ textAlign: 'center' }}>{this.getErrorMessage()}</h2>
        </div>
        {loading ? <Loading /> : null}
      </div>
    );
  }
}
